import {CustomMarkdown} from '@ui/atoms/typography/markdown';
import {splitGoalReflectionResponse} from '../goal-reflection-snapshot';

export const GoalReflectionSnapshot = ({snapshot}: {snapshot: string}) => {
  if (!snapshot) return null;

  return (
    <div
      data-testid="goal-reflection-snapshot"
      className="rounded-[10px] border border-borderLight bg-backgroundLight px-4 py-3">
      <CustomMarkdown
        text={snapshot}
        compact
        className="text-[14px] leading-[22px] text-blackTwo"
      />
    </div>
  );
};

export const GoalReflectionResponse = ({response}: {response: string}) => {
  const {snapshot, answer} = splitGoalReflectionResponse(response);

  return (
    <div className="flex flex-col gap-3">
      <GoalReflectionSnapshot snapshot={snapshot} />
      {answer && (
        <div data-testid="goal-reflection-answer">
          <CustomMarkdown
            text={answer}
            compact
            className="text-[14px] leading-[22px] text-blackTwo"
          />
        </div>
      )}
    </div>
  );
};
